import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import Thead from '../../../../../../core/components/table-components/Thead';
import Tr from '../../../../../../core/components/table-components/Tr';
import ThWithControls from '../../../../../../core/components/table-components/ThWithControls';
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks';
import { reportIsVisibleSelector, salesOfficeEmployeeFiltersSelector } from '../../../../../../store/selectors/reportsSelectors';
import { setSalesOfficeEmployeeFilters } from '../../../../../../store/slices/reportsSlice';
import { useSalesOfficeEmployeeRanges } from '../../../../../hooks/useSalesOfficeEmployeeRanges';
import {
  getSalesOfficeEmployeeReportExcelThunk,
  getSalesOfficeEmployeeReportThunk,
} from '../../../../../../store/thunks/reports/reportsThunks';
import { SearchTableFilterType } from '../../../../../../core/types/coreTypes';
import Dropdown from '../../../../../../core/components/dropdown/Dropdown';
import ThNew from '../../../../../../core/components/table-components/table-new/ThNew';
import { ReportTableColumns } from '../../../../../types/RectificationReportsTypes';

const SalesOfficeEmployeeColumns: React.FC<ReportTableColumns> = ({ columns, totalCount }) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(salesOfficeEmployeeFiltersSelector);
  const reportIsVisible = useAppSelector(reportIsVisibleSelector);

  const [searchVl, setSearchVl] = useState<SearchTableFilterType>({
    orderNumber: filters.orderNumber,
  });

  const { range, rangePatterns, setRange } = useSalesOfficeEmployeeRanges();

  const sortHandle = (field: number) => {
    if (filters?.order?.field === field) {
      const newFilters = {
        ...filters,
        order: { ...filters.order, isAsc: !filters.order.isAsc },
      };
      dispatch(setSalesOfficeEmployeeFilters(newFilters));
      dispatch(getSalesOfficeEmployeeReportThunk({ filters: newFilters }));
    } else {
      const newFilters = {
        ...filters,
        order: { field, isAsc: true },
      };
      dispatch(setSalesOfficeEmployeeFilters(newFilters));
      dispatch(getSalesOfficeEmployeeReportThunk({ filters: newFilters }));
    }
  };

  const onChangeSearchHandle = (v: string, field: string) => {
    setSearchVl({ ...searchVl, [field]: v });
    if (!v) {
      const newFilters = { ...filters, [field]: undefined };
      dispatch(setSalesOfficeEmployeeFilters(newFilters));
      dispatch(getSalesOfficeEmployeeReportThunk({ filters: newFilters }));
    }
  };
  const searchPressHandle = (field: string) => {
    const newFilters = { ...filters, [field]: searchVl[field]?.trim(), page: 1 };
    dispatch(setSalesOfficeEmployeeFilters(newFilters));
    dispatch(getSalesOfficeEmployeeReportThunk({ filters: newFilters }));
  };

  const setRangeHandle = (field: string, value: [number, number]) => {
    const [min, max] = value;
    const newFilters = {
      ...filters,
      [field]: { min, max },
      page: 1,
    };
    dispatch(setSalesOfficeEmployeeFilters(newFilters));
    dispatch(getSalesOfficeEmployeeReportThunk({ filters: newFilters }));
  };

  const exportToExcel = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { page, pageSize, ...rest } = filters;
    dispatch(getSalesOfficeEmployeeReportExcelThunk({ filters: rest }));
  };

  return (
    <Thead>
      <Tr>
        {columns.map((col) => (
          <ThWithControls
            key={col.dataIndex}
            col={col}
            tableFilters={filters}
            sortHandle={sortHandle}
            searchVl={searchVl}
            onChangeSearchHandle={onChangeSearchHandle}
            searchPressHandle={searchPressHandle}
            setRangeHandle={setRangeHandle}
            range={range}
            rangePatterns={rangePatterns}
            setRange={setRange}
            rangeStep={col.dataIndex === 'daysInNewStatus' ? 1 : 0.01}
            totalElements={totalCount}
            className={`salesOfficeEmployeeReportTh--${col.dataIndex}`}
            disabledFilter={!reportIsVisible}
          />
        ))}
        <ThNew action>
          <Dropdown
            disabled={!totalCount}
            menuItems={[
              {
                label: 'Export to Excel',
                icon: <FontAwesomeIcon icon={faFileExcel} />,
                key: 'export-to-excel',
                onClick: exportToExcel,
              },
            ]}
            icon={<FontAwesomeIcon icon={faGear} />}
          />
        </ThNew>
      </Tr>
    </Thead>
  );
};

export default SalesOfficeEmployeeColumns;
